import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import productimage1 from "../../images/product-img-1.jpg";
import productimage2 from "../../images/product-img-2.jpg";
import productimage3 from "../../images/product-img-3.jpg";
import productimage4 from "../../images/product-img-4.jpg";
import productMain from "../../images/almoune/hallab-baklava.jpg";
import { MagnifyingGlass } from "react-loader-spinner";
import ScrollToTop from "../ScrollToTop";

const initialWishlist = [
  {
    id: 1,
    image: productMain,
    title: "Hallab 1881 - Le Baklava Frais du Liban",
    unit: "Coffret",
    price: "29,90 EUR",
    status: "En stock",
    statusClass: "bg-success",
    actionLabel: "Voir le produit",
    actionLink: "/SingleShop",
  },
  {
    id: 2,
    image: productimage1,
    title: "Pain Libanais - 5 pieces",
    unit: "Sachet",
    price: "1,49 EUR",
    status: "En stock",
    statusClass: "bg-success",
    actionLabel: "Ajouter au panier",
    actionLink: "/ShopCart",
  },
  {
    id: 3,
    image: productimage2,
    title: "Cafe Najjar Nature 220g",
    unit: "220g",
    price: "4,99 EUR",
    status: "En stock",
    statusClass: "bg-success",
    actionLabel: "Ajouter au panier",
    actionLink: "/ShopCart",
  },
  {
    id: 4,
    image: productimage3,
    title: "Zaatar Premium Naturel 500g",
    unit: "500g",
    price: "10,95 EUR",
    status: "Disponible bientot",
    statusClass: "bg-warning text-dark",
    actionLabel: "Contacter Almoune",
    actionLink: "/Contact",
  },
  {
    id: 5,
    image: productimage4,
    title: "Creme a dessert Puck 170g",
    unit: "170g",
    price: "1,87 EUR",
    status: "En stock",
    statusClass: "bg-success",
    actionLabel: "Ajouter au panier",
    actionLink: "/ShopCart",
  },
];

const ShopWishList = () => {
  const [loaderStatus, setLoaderStatus] = useState(true);
  const [wishlistItems, setWishlistItems] = useState(initialWishlist);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoaderStatus(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  const removeItem = (id) => {
    setWishlistItems((items) => items.filter((item) => item.id !== id));
  };

  return (
    <div>
      {loaderStatus ? (
        <div className="loader-container">
          <MagnifyingGlass
            visible={true}
            height="100"
            width="100"
            ariaLabel="magnifying-glass-loading"
            wrapperStyle={{}}
            wrapperclassName="magnifying-glass-wrapper"
            glassColor="#c0efff"
            color="#0aad0a"
          />
        </div>
      ) : (
        <>
          <ScrollToTop />
          <section className="my-14">
            <div className="container">
              <div className="row">
                <div className="offset-lg-1 col-lg-10">
                  <div className="mb-8">
                    <h1 className="mb-1">Mes favoris</h1>
                    <p>
                      {wishlistItems.length} produit{wishlistItems.length > 1 ? "s" : ""} conserve
                      {wishlistItems.length > 1 ? "s" : ""} dans votre selection Almoune.
                    </p>
                  </div>

                  {wishlistItems.length === 0 ? (
                    <div className="card border-0 shadow-sm">
                      <div className="card-body p-5 text-center">
                        <h4 className="mb-2">Votre liste de favoris est vide</h4>
                        <p className="text-muted mb-4">
                          Ajoutez vos produits Almoune preferes pour les retrouver facilement.
                        </p>
                        <Link to="/Shop" className="btn btn-primary">
                          Retour a la boutique
                        </Link>
                      </div>
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table align-middle">
                        <thead className="table-light">
                          <tr>
                            <th />
                            <th>Produit</th>
                            <th>Prix</th>
                            <th>Disponibilite</th>
                            <th>Action</th>
                            <th className="text-center">Supprimer</th>
                          </tr>
                        </thead>
                        <tbody>
                          {wishlistItems.map((item) => (
                            <tr key={item.id}>
                              <td style={{ width: "120px" }}>
                                <Link to={item.actionLink}>
                                  <img
                                    src={item.image}
                                    className="img-fluid rounded"
                                    alt={item.title}
                                    style={{ maxHeight: "90px", objectFit: "cover", width: "100%" }}
                                  />
                                </Link>
                              </td>
                              <td>
                                <div>
                                  <h5 className="fs-6 mb-1">
                                    <Link to={item.actionLink} className="text-inherit text-decoration-none">
                                      {item.title}
                                    </Link>
                                  </h5>
                                  <small className="text-muted">{item.unit}</small>
                                </div>
                              </td>
                              <td className="fw-semibold">{item.price}</td>
                              <td>
                                <span className={`badge ${item.statusClass}`}>{item.status}</span>
                              </td>
                              <td>
                                <Link to={item.actionLink} className="btn btn-primary btn-sm">
                                  {item.actionLabel}
                                </Link>
                              </td>
                              <td className="text-center">
                                <button
                                  type="button"
                                  className="btn btn-link text-muted p-0"
                                  onClick={() => removeItem(item.id)}
                                  aria-label={`Supprimer ${item.title}`}
                                >
                                  <i className="fas fa-trash-alt" />
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </div>
  );
};

export default ShopWishList;
